
import { Prop, Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'ButtonReactivate'
})
export default class ButtonReactivate extends Vue {
  @Prop({ type: String, default: 'button' }) tag!: string
  @Prop({ type: Boolean, default: false }) colored: boolean
  @Prop({ type: String, default: 's' }) size!: string

  get iconSize() {
    return this.size === 'l' ? '16' : '14'
  }
}

